import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { BRAND } from "../lib/data";

export default function StickyCTA() {
  return (
    <div className="contact-shortcuts fixed bottom-5 left-5 z-40 flex flex-col gap-3" data-testid="sticky-cta">
      <a
        href={`https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent("Hi Crew Connect FinInvesto, I'm interested in your funding solutions.")}`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center w-12 h-12 rounded-full bg-[#25D366] text-white shadow-lg hover:scale-110 transition-transform"
        data-testid="sticky-whatsapp"
        aria-label="WhatsApp"
      >
        <MessageCircle size={22} />
        <span className="contact-shortcut-label">WhatsApp</span>
      </a>
      <a
        href={`tel:${BRAND.phone}`}
        className="flex items-center justify-center w-12 h-12 rounded-full bg-brandred text-white shadow-lg hover:scale-110 transition-transform"
        data-testid="sticky-call"
        aria-label="Call"
      >
        <Phone size={22} />
        <span className="contact-shortcut-label">Call us</span>
      </a>
    </div>
  );
}
